import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';

export const getValidityPeriod = (from: string, to: string) =>
  `c ${formatDateLocale({
    date: from,
    dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
    parseFormat: DATE_FORMAT_ISO_FNS,
  })} по ${formatDateLocale({
    date: to,
    dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
    parseFormat: DATE_FORMAT_ISO_FNS,
  })}`;
